const pageNameKey = "readOnlyConnectedSourceView";

export const readOnlyConnectedSourceViewEn = {
  [pageNameKey]: {
    subTitle: "Connect to Source",
    editStructure: "Edit Structure",
    connectivity: "Connectivity",
    securityMode: "Security Mode",
    securityPolicy: "Security Policy",
  },
};

export const readOnlyConnectedSourceViewPtBr = {
  [pageNameKey]: {
    subTitle: "Conectar à fonte",
    editStructure: "Editar estrutura",
    connectivity: "Conectividade",
    securityMode: "Modo de segurança",
    securityPolicy: "Política de Segurança",
  },
};

export const readOnlyConnectedSourceViewDe = {
  [pageNameKey]: {
    subTitle: "Mit Source verbinden",
    editStructure: "Struktur bearbeiten",
    connectivity: "Konnektivität",
    securityMode: "Sicherheitsmodus",
    securityPolicy: "Sicherheitsrichtlinie",
  },
};

export const readOnlyConnectedSourceViewZhHans = {
  [pageNameKey]: {
    subTitle: "连接到源",
    editStructure: "编辑结构",
    connectivity: "连接性",
    securityMode: "安全模式",
    securityPolicy: "安全策略",
  },
};

export const readOnlyConnectedSourceViewIt = {
  [pageNameKey]: {
    subTitle: "Connetti alla macchina",
    editStructure: "Modifica struttura",
    connectivity: "Connettività",
    securityMode: "Modalità di sicurezza",
    securityPolicy: "Policy di sicurezza",
  },
};

export const readOnlyConnectedSourceViewEs = {
  [pageNameKey]: {
    subTitle: "Conectar a la fuente",
    editStructure: "Editar estructura",
    connectivity: "Conectividad",
    securityMode: "Modo de seguridad",
    securityPolicy: "Política de seguridad",
  },
};

export const readOnlyConnectedSourceViewNl = {
  [pageNameKey]: {
    connectivity: "Connectiviteit",
    editStructure: "Structuur bewerken",
    securityMode: "Beveiligingsmodus",
    securityPolicy: "Beveiligingsbeleid",
    subTitle: "Verbinden met bron",
  },
};

export const readOnlyConnectedSourceViewTr = {
  [pageNameKey]: {
    connectivity: "Bağlantı",
    editStructure: "Yapıyı Düzenle",
    securityMode: "Güvenlik Modu",
    securityPolicy: "Güvenlik Politikası",
    subTitle: "Kaynağa Bağlan",
  },
};
